// Organizations API client — v2 OrgSwitcher source of truth.
//
// CHG-1525 / ITER-3644 (OrgSwitcher real-data fix). Replaces the
// CHG-1167 MOCK_ORGS the popover renders today. Calls
// GET /api/v1/organizations which is gated to org-admin or
// platform-admin roles (src/api/app/routers/organizations.py:430 —
// list_orgs); the backend automatically scopes the result set:
//   - platform-admin → all orgs across tenants (no host_variant
//     restriction)
//   - org-admin       → just their own organization
// Donor-only accounts get a 403 and the OrgSwitcher renders the
// empty-state branch (the brand wordmark stays in the top bar).
//
// Response envelope is OrgPagedEnvelope { data, pagination }; only
// `data` is consumed by the OrgSwitcher today. per_page is set to
// 100 (the max the endpoint accepts) so a single fetch covers the
// common case; pagination edges (>100 orgs visible to one
// platform-admin) are a follow-up.

import { apiClient } from "./client";

export interface OrgListItem {
  id: string;
  name: string;
  slug: string;
  logo_url?: string | null;
}

interface OrgsPagedEnvelope {
  data: OrgListItem[];
  pagination?: {
    page: number;
    per_page: number;
    total: number;
    pages: number;
  };
}

export async function listOrganizations(
  opts: { perPage?: number } = {},
): Promise<OrgListItem[]> {
  const perPage = opts.perPage ?? 100;
  const r = await apiClient().get<OrgsPagedEnvelope>("/organizations", {
    params: { page: 1, per_page: perPage },
  });
  return Array.isArray(r.data?.data) ? r.data.data : [];
}
